import { Config } from '@penji/frontend/config';

export const appIdentifier = Config.APP_IDENTIFIER;
export const appVersion = Config.APP_VERSION;
export const buildVersion = Config.BUILD_VERSION;
